// Personal libs
import { Repository } from './common/repository.class';
import {
  IApiUpdatePassword,
  IApiUpdateUsername,
  apiUpdatePassword,
  apiUpdateUsername,
} from '@data/datasource/remote/user.api';
import { ApiError } from '@shared/error/api.error';
import { $t } from '@i18n/utils';
import { sessionManager } from '@shared/service/sessionManager/session-manager.class';

class UserRepository extends Repository {
  constructor() {
    super();
  }

  /*****************************************
   *
   * POST FUNCTIONS
   *
   *****************************************/
  // Update user roles
  updatePassword(params: IApiUpdatePassword): Promise<string | undefined> {
    return apiUpdatePassword(params).catch((err: ErrorConstructor) => {
      const badPassword = 'Mot de passe non valide';

      if (err instanceof ApiError) {
        if (err.code === 'USER_UPDATE_PASSWORD_ERR_01') {
          throw new Error('Utilisateur inconnu');
        } else if (err.code === 'USER_UPDATE_PASSWORD_ERR_02') {
          throw new Error(badPassword);
        } else if (err.code === 'USER_UPDATE_PASSWORD_ERR_03') {
          throw new Error(badPassword);
        } else if (err.code === 'USER_UPDATE_PASSWORD_ERR_04') {
          throw new Error(badPassword);
        } else if (err.code === 'USER_UPDATE_PASSWORD_ERR_05') {
          throw new Error(
            "Erreur technique lors de l'envoi du nouveau mot de passe à l'utilisateur",
          );
        } else if (err.code === 'USER_UPDATE_PASSWORD_ERR_06') {
          throw new Error(
            "Erreur technique lors de la modification de l'utilisateur",
          );
        }
      } else {
        if (sessionManager.isOnline.value) {
          throw new Error($t('generic.unknownError'));
        } else {
          throw new Error($t('generic.healthCheck.backendNotReachable'));
        }
      }
      return Promise.resolve(undefined);
    });
  }

  // Update user roles
  updateUsername(params: IApiUpdateUsername): Promise<string | undefined> {
    return apiUpdateUsername(params).catch((err: ErrorConstructor) => {
      if (err instanceof ApiError) {
        if (err.code === 'USER_UPDATE_USERNAME_ERR_01') {
          throw new Error('Utilisateur inconnu');
        } else if (err.code === 'USER_UPDATE_USERNAME_ERR_02') {
          throw new Error("Nom d'utilisateur invalide.");
        } else if (err.code === 'USER_UPDATE_USERNAME_ERR_03') {
          throw new Error("Nom d'utilisateur existant.");
        } else {
          throw new Error(
            "Erreur technique lors de la modification de l'utilisateur",
          );
        }
      } else {
        if (sessionManager.isOnline.value) {
          throw new Error($t('generic.unknownError'));
        } else {
          throw new Error($t('generic.healthCheck.backendNotReachable'));
        }
      }
      return Promise.resolve(undefined);
    });
  }
}

export default new UserRepository();
